import config from 'utils/apiconfig';
import request from 'utils/request';

const {api} = config;
const {challengeNum} = api;


export async function getUKeyChallenge() {
    return request({
        url: challengeNum,
        method: 'POST',
    });
}


/**
 * 获取UKey列表
 */
export async function getUKeyList() {
    return request({
        url: "https://xk.sheca.com:18456/uk/action",
        method: 'POST',
        data: {
            type: 100
        }
    });
}


/**
 * 获取证书
 * @param keySN     UKEY介质序列号(唯一标识)
 * @param asymid    非对称算法标识。1:RSA，2:SM2
 * @param usage     用途标识。1:加密，2:签名
 * @returns {Promise<*>}
 */
export async function getUKeyCert(keySN, asymid, usage) {
    return request({
        url: "https://xk.sheca.com:18456/uk/action",
        method: 'POST',
        data: {
            type: 200,
            keySN,
            asymid,
            usage
        }
    });
}


/**
 * 验证PIN码
 * @param keySN     UKEY介质序列号(唯一标识)
 * @param asymid    非对称算法标识。1:RSA，2:SM2
 * @param pin       用户PIN码。同私钥保护口令
 * @returns {Promise<*>}
 */
export async function verifyUKeyPINCode(keySN, asymid, pin) {
    return request({
        url: "https://xk.sheca.com:18456/uk/action/101",
        method: 'POST',
        data: {
            type: 101,
            keySN,
            asymid,
            pin
        }
    });
}


/**
 * 数字签名
 * @param keySN     UKEY介质序列号(唯一标识)
 * @param asymid    非对称算法标识。1:RSA，2:SM2
 * @param pin       用户PIN码。同私钥保护口令
 * @param raw       签名原文
 * @param wrapperType   数据包装类型。0:直接对原文签名（可缺省），1:需要Base64解码后，再签名
 * @param signMethodID  签名算法标识，65538:sha1withRSA，65540:sha256withRSA（可缺省）
 * @returns {Promise<*>}
 */
export async function uKeySign(keySN, asymid, pin, raw, wrapperType, signMethodID) {
    return request({
        url: "https://xk.sheca.com:18456/uk/action/300",
        method: 'POST',
        data: {
            type: 300,
            keySN,
            asymid,
            pin,
            raw,
            wrapperType,
            signMethodID
        }
    });
}

